import axios from 'plugins/axios'

export const state = {
  order: null
}

export const getters = {
  order (state) {
    return state.order
  }
}

export const mutations = {
  set (state, order) {
    state.order = order
  },
  clearOrder (state) {
    state.order = null
  }
}

export const actions = {
  async create ({state, commit, getters}, order) {
    if (getters.order) {
      order = Object.assign({}, getters.order, order)
    }

    let response = await axios.post(`/order?include=products,payment,shippingOption`, order)

    await commit('set', response.data.data)

    return response.data.data
  }
}



// WEBPACK FOOTER //
// ./client/store/order.js